webpackJsonp([80228475665765],{

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBsGrid = __webpack_require__(34);
	
	var _reactBodyClassname = __webpack_require__(33);
	
	var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactFeather = __webpack_require__(75);
	
	var _gatsbyLink = __webpack_require__(74);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactWindowSize = __webpack_require__(53);
	
	var _reactWindowSize2 = _interopRequireDefault(_reactWindowSize);
	
	var _get = __webpack_require__(103);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactFab = __webpack_require__(105);
	
	var _Space = __webpack_require__(36);
	
	var _Space2 = _interopRequireDefault(_Space);
	
	var _Title = __webpack_require__(84);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Page = __webpack_require__(35);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global graphql */
	
	
	var Element = function (_Component) {
	  _inherits(Element, _Component);
	
	  function Element() {
	    _classCallCheck(this, Element);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Element.prototype.componentDidMount = function componentDidMount() {
	    if (Prism) Prism.highlightAll();
	  };
	
	  Element.prototype.getDocs = function getDocs() {
	    var edges = (0, _get2.default)(this.props, 'data.allMarkdownRemark.edges');
	    if (!edges) return '';
	    var html = edges.filter(function (edge) {
	      return edge.node.html.indexOf('name="guides"') > -1;
	    })[0].node.html;
	
	    return html.slice(html.indexOf('<h2>'));
	  };
	
	  Element.prototype.getSideLength = function getSideLength() {
	    var windowWidth = this.props.windowWidth;
	
	    var sideLength = 340;
	    if (windowWidth < 1200) sideLength = 270;
	    if (windowWidth < 992) sideLength = 210;
	    if (windowWidth < 768) sideLength = 258;
	    if (windowWidth < 570) sideLength = windowWidth - 100;
	    if (windowWidth === 0) sideLength = 340;
	    return sideLength;
	  };
	
	  Element.prototype.scrollTo = function scrollTo(key) {
	    return function () {
	      document.querySelector('[name="layouts__' + key + '"]').scrollIntoView({
	        behavior: 'smooth',
	        block: 'center',
	        inline: 'nearest'
	      });
	    };
	  };
	
	  Element.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactBodyClassname2.default,
	      { className: 'no-padding' },
	      _react2.default.createElement(
	        _Page2.default,
	        { fluid: true, name: 'page-build' },
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: 'Potion.js - React + D3',
	          meta: [{
	            property: 'og:url',
	            content: 'http://numberpicture.com/build'
	          }, {
	            property: 'og:title',
	            content: 'Potion.js - React + D3'
	          }, {
	            property: 'og:description',
	            content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.'
	          }, {
	            name: 'twitter:title',
	            content: 'Potion.js - React + D3'
	          }, {
	            name: 'twitter:description',
	            content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.'
	          }, {
	            charSet: 'utf-8'
	          }]
	        }),
	        _react2.default.createElement(
	          _reactFab.Fab,
	          { style: { right: '20px', bottom: '20px' } },
	          _react2.default.createElement(
	            _reactFab.FabButton,
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: this.scrollTo('top') },
	              _react2.default.createElement(_reactFeather.ChevronUp, null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBsGrid.Container,
	          { fluid: true },
	          _react2.default.createElement(
	            _reactBsGrid.Row,
	            null,
	            _react2.default.createElement(
	              _reactBsGrid.Container,
	              null,
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { lg: 12 },
	                  _react2.default.createElement('div', { name: 'layouts__top' }),
	                  _react2.default.createElement(
	                    _Title2.default,
	                    null,
	                    'Guides'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { lg: 8 },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Here you will find guides for using features of Potion in powerful and alternative ways.'
	                  )
	                ),
	                _react2.default.createElement(_Space2.default, { half: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'page page-docs' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content' },
	                  _react2.default.createElement('div', {
	                    dangerouslySetInnerHTML: {
	                      __html: this.getDocs()
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(_Space2.default, null),
	              _react2.default.createElement(_Space2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Element;
	}(_react.Component);
	
	exports.default = (0, _reactWindowSize2.default)(Element);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-guides-js-17dad275afecd4a58554.js